import { DomainFilterValue, FilterDetails, UsersFilters } from '../../types/filters';
import {
    LAST_SEEN_FILTER_DETAILS,
    MATCHING_STATUS_FILTER_DETAILS,
    STATUS_FILTER_DETAILS,
    TOKEN_FILTER_DETAILS
} from './consts';
import { AdGroup } from '../../types/AdGroup';

export const DOMAIN_FILTER_ID = 'domain';
export const GROUP_FILTER_ID = 'group';

const getDomainBaseFilters = (domains: DomainFilterValue[]): FilterDetails<UsersFilters> => {
    const domainOptions = domains.map((domain) => ({ value: domain, label: domain }));

    return {
        id: DOMAIN_FILTER_ID,
        label: 'Domain',
        multiple: true,
        searchable: true,
        searchPlaceholder: 'Search by name',
        options: domainOptions
    };
};

const getGroupsBaseFilters = (groups: AdGroup[]): FilterDetails<UsersFilters> => {
    const groupOptions = groups.map(({ guid, name, domainName }) => ({
        value: guid,
        label: name,
        subtitle: domainName
    }));

    return {
        id: GROUP_FILTER_ID,
        label: 'Group / OU',
        multiple: true,
        searchable: true,
        searchPlaceholder: 'Search by name',
        options: groupOptions
    };
};

export const getUsersTableBaseFilters = (params: {
    domains: DomainFilterValue[];
    groups: AdGroup[];
    hasAccountMatching: boolean;
}) => {
    const { domains, groups, hasAccountMatching } = params;
    const domainBaseFilterDetails: FilterDetails<UsersFilters> = getDomainBaseFilters(domains);
    const groupBaseFilterDetails: FilterDetails<UsersFilters> = getGroupsBaseFilters(groups);
    const baseFilters = [
        STATUS_FILTER_DETAILS,
        domainBaseFilterDetails,
        groupBaseFilterDetails,
        TOKEN_FILTER_DETAILS,
        LAST_SEEN_FILTER_DETAILS
    ];

    if (hasAccountMatching) {
        baseFilters.push(MATCHING_STATUS_FILTER_DETAILS);
    }

    return baseFilters;
};
